import type { Entry } from 'contentful';

function getFirstModule(items: Entry[]): Entry | undefined {
    const firstItem = items[0];

    return firstItem?.sys.contentType?.sys.id === 'container'
        ? getFirstModule(firstItem.fields.items as Entry[])
        : firstItem;
}

export function applyHomepageCampaignHeroH1(pageItems: Entry[]): void {
    const firstModule = getFirstModule(pageItems);

    if (firstModule?.sys.contentType?.sys.id === 'campaignHero') {
        firstModule.fields.isH1 = true;
    }
}
